// @ts-nocheck

import { type StateType } from '../../../states';
import { type Selector } from '../../../types/selectors';
import { type BetslipOptionsState } from '../reducers/betslipOptions';

const emptyObj = {};

export const selectBetslipOptions: Selector<BetslipOptionsState> = (state: StateType) =>
  state.betslipOptions ?? emptyObj;

export const selectBetslipOptionsByBetslipId: Selector<BetslipOptionsState | undefined> = (
  state: StateType,
  { betslipId }: { betslipId: string } = {},
) => {
  const betslips = selectBetslipOptions(state);
  return betslips[betslipId];
};
